<template>
  <div class="right-side-bar-details-overlay" @click="$emit('close')"/>
  <div class="right-side-bar-details">
    <div class="header-project-details">
      <span class="header-title">Details</span>
      <div class="close-icon" @click="$emit('close')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.25 6.75L6.75 17.25M6.75 6.75L17.25 17.25" stroke="#64748B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <div class="project-info-content">
      <div class="project-preview">
        <svg width="56" height="28" viewBox="0 0 56 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M54.6083 6.93272C53.8137 7.96516 52.9145 8.92967 51.9227 9.81558C50.8174 10.8227 49.5104 11.6993 48.4933 11.6993C48.2154 11.6993 47.9062 11.6114 47.9062 10.8161C47.9734 9.88486 48.2154 8.96965 48.6217 8.10905C48.6217 8.10905 48.0571 7.9372 46.9294 7.52555C46.3424 6.93006 45.5029 6.58235 44.6157 6.56636C43.3461 6.58901 42.1646 7.14453 41.4237 8.06641C40.8726 8.68988 40.4663 9.18945 40.1347 9.56246C39.0877 10.7628 37.6642 11.706 36.5544 11.706C36.2751 11.718 36.0047 11.618 35.8165 11.4342C35.6283 11.2504 35.5402 11.0012 35.5775 10.7534C35.6657 10.1873 35.827 9.63307 36.0615 9.10153C36.3931 8.0784 35.9853 7.38167 34.656 7.18984C33.0891 9.44923 31.9704 11.7046 29.8882 11.7046C29.0159 11.7046 28.3482 11.1571 28.3482 10.1047C28.3482 7.96917 30.5857 5.04633 32.1615 2.85088C33.4685 1.00313 32.4304 0.263774 31.5476 0C31.2878 0.319726 28.7321 3.75945 27.219 5.62984C25.9613 7.19384 23.0786 7.95318 21.4848 8.00514C20.9412 7.13122 19.918 6.58235 18.7992 6.56503C16.6588 6.56503 15.6073 8.06908 15.2936 8.44875C14.9799 8.82842 14.3182 9.57978 14.2466 9.64906C12.4108 11.6167 11.4355 11.6806 10.6662 11.6806C9.85818 11.6327 9.06653 11.4542 8.33016 11.1531C10.4347 7.8546 12.6454 4.85051 13.9613 3.02807C15.2145 1.29222 14.4094 0.297072 13.2533 0.00931819C12.8813 0.484911 9.35033 4.95575 5.95673 10.3538L3.76403 9.6304C3.76403 9.6304 2.58702 11.4941 4.13147 12.1456C4.20317 12.1816 4.31967 12.2295 4.47651 12.2975L4.72745 12.4054C2.15386 16.7763 0 21.391 0 24.5896C0 26.9449 1.37417 28 2.7349 28C3.6296 28 5.4205 27.4964 7.60573 24.1406C9.08744 21.8613 9.93734 19.3421 9.93734 17.3984C9.91195 16.0849 9.63711 14.7833 9.12777 13.5511C9.5221 13.6336 9.9239 13.6803 10.3272 13.6909C11.9523 13.7549 13.3578 13.4911 14.9471 11.7752C15.3653 12.8983 16.5274 13.6643 17.8523 13.6909C20.3765 13.6909 21.9524 11.4235 21.9524 10.1433C23.573 9.9448 25.1189 9.40393 26.4602 8.56732C26.2825 9.00428 26.1869 9.46254 26.1734 9.92748C26.1734 12.4027 27.8254 13.6869 29.8747 13.6869C31.3998 13.6523 32.8128 12.9609 33.6657 11.8312C33.6657 12.8064 34.5066 13.6869 36.414 13.6869H36.7814C36.9293 13.6869 37.0369 13.663 37.1489 13.651L37.485 13.587C37.6956 13.5404 37.9047 13.4804 38.1078 13.4112C38.8457 13.1434 39.5328 12.777 40.1496 12.3281C40.3737 12.1722 40.5977 12.0044 40.7994 11.8365C41.2296 12.9209 42.3588 13.6603 43.6463 13.7003C44.6799 13.6456 45.6374 13.1927 46.2692 12.46C46.6247 13.2233 47.4701 13.7136 48.3962 13.6923C51.3954 13.6923 54.7577 9.78094 55.3297 9.08154C55.9033 8.38214 56.1931 7.29773 54.6098 6.94603M5.56688 22.9537C4.37195 24.8294 3.32938 25.9444 2.96642 25.9444C2.711 25.9444 2.49143 25.3409 2.49143 24.5883C2.49143 21.8533 4.38988 17.7621 6.72597 13.7908C7.24128 14.6101 7.48624 15.7905 7.48624 17.4184C7.48624 18.9225 6.77376 21.0819 5.56539 22.9723M19.4639 10.2445C19.1054 11.1837 18.3093 11.8965 17.673 11.8445C17.0367 11.7926 16.8276 10.9693 17.1846 10.0287C17.5431 9.08953 18.3347 8.37281 18.9755 8.42876C19.6163 8.48472 19.8209 9.30401 19.4684 10.2445M43.5104 11.8445C42.8696 11.7926 42.665 10.9693 43.022 10.0287C43.3804 9.08953 44.1721 8.37281 44.8129 8.42876C45.4536 8.48472 45.6583 9.30401 45.3013 10.2445C44.9473 11.1837 44.1512 11.8965 43.5104 11.8445ZM38.0406 2.07155C38.7874 2.07155 39.1056 2.87087 38.7441 3.89133C38.3812 4.91045 37.4909 5.71111 36.7426 5.71111C35.9943 5.71111 35.6776 4.91179 36.0391 3.89133C36.3931 2.88819 37.2923 2.07155 38.0406 2.07155Z" fill="#CCCCCC"/>
        </svg>
      </div>
      <div class="project-name">
        {{projectData.name}}
      </div>
      <div class="project-description">
        {{projectData.description}}
      </div>
      <div class="project-info-values">
        <div class="project-info-label">Created by</div>
        <div class="project-info-value">{{projectData?.ownerProfile?.email}}</div>
        <div class="project-info-label">Last modified</div>
        <div class="project-info-value">{{formattedDate(projectData.updatedAt)}}</div>
        <!-- <div class="project-info-label">Total documents</div>
        <div class="project-info-value">
          {{projectData.totalDocuments === 1 ?
          projectData.totalDocuments + " document" : projectData.totalDocuments  + " documents" }}
        </div> -->
        <div class="project-info-label">Shared with</div>
        <div class="project-info-value">
          {{projectData.totalCollaboratorCount <= 1 ? "No people" : projectData.totalCollaboratorCount === 2
          ? projectData.totalCollaboratorCount-1  + " person" : projectData.totalCollaboratorCount-1  + " people"}}
        </div>
      </div>
      <div class="project-info-button" v-if="canEditProject()">
        <button class="edit-project-button" @click.stop="$emit('editProject', projectId); $emit('close')">
          <span>{{'Edit Project Details'}}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { inject, onMounted, ref } from "vue";

export default {
  name: "ProjectDetails",
  props: [
    'projectId',
    'projectPermissions',
    'projectData'
  ],
  emits: ["close", "editProject"],
  setup(props) {
    const ownerName = ref('');
    const $fetch = inject('$fetch');
    onMounted(() => {
      getOwnerName(props.projectData.ownerEmail, props.projectId)
        .then(name => {
          ownerName.value = name
        })
    })
    function formattedDate(date) {
      return moment(date).format('LLL');
    }
    function canEditProject() {
      return props.projectPermissions?.includes('RENAME_PROJECT')
    }
    async function getOwnerName(ownerEmail, projectId) {
      const { collaborators } = await $fetch.getProjectCollaborators(projectId);
      const collaborator = collaborators.find(person => person.email === ownerEmail);
      return collaborator?.profile?.username || ownerEmail;
    }
    return {
      formattedDate,ownerName,
      canEditProject,
    }
  }
};
</script>

<style scoped lang="scss">
.right-side-bar-details-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 300px;
  width: 100%;
  height: 100%;
  background-color:transparent;
  z-index: 100;
}
.right-side-bar-details {
  top: 0px;
  padding-bottom: 0px;
  position: fixed;
  display: flex;
  flex-direction: column;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 320px;
  z-index: 1000;
  background: #FFFFFF;
  box-shadow: -4px 0px 8px rgba(51, 65, 85, 0.15);
  .header-project-details {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    background: #F8FAFC;
    .header-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #334155;
    }
    .close-icon {
      cursor: pointer;
    }
  }
  .project-info-content {
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    align-self: center;
    text-align: start;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    padding: 0 20px;
    overflow-y: auto;
    overflow-x: hidden;
    .project-preview {
      margin: 16px;
      background: #F1F5F9;
      border: 1px solid #E2E8F0;
      width: 288px;
      height: 144px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
    }
    .project-name {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #334155;
      text-align: start;
      white-space: pre-line;
      word-break: break-word;
      word-wrap: break-word;
      width: 100%;
    }
    .project-description {
      margin-top: 8px;
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #334155;
      text-align: start;
      white-space: pre-line;
      word-break: break-word;
      word-wrap: break-word;
    }
    .project-info-values {
      width: 100%;
      margin-top: 16px;
      .project-info-label {
        width: 100%;
        margin-bottom: 2px;
        font-family: Inter, serif;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #64748B;
      }
      .project-info-value {
        width: 100%;
        margin-bottom: 16px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #334155;
      }
    }
    .project-info-button {
      width: calc(100% + 40px);
      background: #F8FAFC;
      display: flex;
      margin-top: auto;
      justify-content: center;
      align-items: center;
      padding: 16px;
      .edit-project-button {
        display: flex;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #334155;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        width: 288px;
        height: 36px;
      }
    }
  }
}
</style>
